import React, { useState } from 'react'
import styled from 'styled-components'
import { useSelector, useDispatch } from 'react-redux'
import { EmailTextBox } from '../TextBox/EmailTextBox'
import { PasswordTextBox } from '../TextBox/PasswordTextBox'
import { Button, ButtonThemeType } from '../Button'
import { Link } from '../Link'
import { login } from '../../states/currentUser/actions'
import { showModal } from '../../states/modals/actions'
import { ModalType } from '../../states/modals/ModalType.constants'
import { Form } from './Form'
import { ButtonType } from '../Button/ButtonType.constants'

const SignUpLink = styled(Link)`
  display: block;
  width: 100%;
  margin-top: 1rem;
`

const ForgotLink = styled(Link)`
  font-size: 0.9rem;
  margin-bottom: 0.5rem;
  display: block;
  text-align: right;
  width: 100%;
  & > div {
    justify-content: flex-end;
  }
`

interface ILoginFormProps {
  className?: string
  hasSignUp?: boolean
  isAuthByCognito?: boolean
  isAuthByFacebook?: boolean
  isAuthByGoogle?: boolean
}

const LoginButton = styled(Button).attrs({
  theme: ButtonThemeType.PRIMARY,
  type: ButtonType.SUBMIT,
  children: 'Login',
  label: 'Login',
})``

interface ILoginFormFields {
  email: string
  password: string
}

const LoginForm: React.FC<ILoginFormProps> = ({
  className,
  hasSignUp = false,
  isAuthByCognito,
  isAuthByFacebook,
  isAuthByGoogle,
}) => {
  const dispatch = useDispatch()
  const { isLoggingIn } = useSelector(({ currentUser }) => currentUser)
  const [formFields, setFormFields] = useState<ILoginFormFields>({
    email: '',
    password: '',
  })
  return (
    <Form
      formFields={formFields}
      onChange={(ff) => setFormFields(ff)}
      className={className}
      onSubmit={() => {
        if (isLoggingIn) {
          return
        }
        const { email, password } = formFields
        dispatch(login(email, password))
      }}
    >
      <EmailTextBox
        labelText="Email"
        name="email"
        validation="email"
        required
      />
      <PasswordTextBox
        labelText="Password"
        name="password"
        validation="password"
        required
      />
      <ForgotLink onClick={() => dispatch(showModal(ModalType.FORGOT))}>
        Forgot?
      </ForgotLink>
      <LoginButton disabled={isLoggingIn} />
      {hasSignUp && (
        <SignUpLink
          onClick={() => {
            dispatch(
              showModal(ModalType.SIGN_UP, {
                props: {
                  isAuthByCognito,
                  isAuthByFacebook,
                  isAuthByGoogle,
                },
              })
            )
          }}
        >
          Sign up
        </SignUpLink>
      )}
    </Form>
  )
}

export { LoginForm }
